var _path, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoingWell5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 86,
    viewBox: "0 0 84 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1094 26.4252C12.1094 35.0488 19.1662 41.9596 27.972 41.9596C36.7747 41.9596 43.8347 35.0488 43.8347 26.4252C43.8347 17.8015 36.7747 10.8907 27.972 10.8907C19.1662 10.8907 12.1094 17.8015 12.1094 26.4252ZM51.9453 59.5482C51.9453 51.5653 40.9021 49.5681 27.9727 49.5681C14.973 49.5681 3.99998 51.6341 3.99998 59.6233C3.99998 67.6061 15.0432 69.6034 27.9727 69.6034C40.9724 69.6034 51.9453 67.5374 51.9453 59.5482Z",
    fill: "url(#paint0_linear_4139_1145)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_4139_1145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1791 54.688C41.0733 54.688 47.8158 56.0144 47.8158 61.3161C47.8158 66.6219 41.1162 67.9941 33.1791 67.9941C25.2849 67.9941 18.5424 66.6676 18.5424 61.3659C18.5424 56.0601 25.2421 54.688 33.1791 54.688Z",
    fill: "#0062FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_4139_1145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8485 34.2853C27.4165 34.2853 23.8648 30.7336 23.8648 26.3016C23.8648 21.8697 27.4165 18.318 31.8485 18.318C36.2788 18.318 39.8321 21.8697 39.8321 26.3016C39.8321 30.7336 36.2788 34.2853 31.8485 34.2853Z",
    fill: "#0062FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_4139_1145)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_4139_1145)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_4139_1145",
    maskUnits: "userSpaceOnUse",
    x: 18.9929,
    y: 4,
    width: 65,
    height: 79,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 18.9929,
    y: 4,
    width: 65,
    height: 79
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7514 25.3725C30.7514 36.6819 40.006 45.7451 51.5544 45.7451C63.0985 45.7451 72.3573 36.6819 72.3573 25.3725C72.3573 14.0631 63.0985 5 51.5544 5C40.006 5 30.7514 14.0631 30.7514 25.3725ZM82.9929 68.8132C82.9929 58.3441 68.5103 55.7248 51.5541 55.7248C34.5057 55.7248 20.1153 58.4343 20.1153 68.9116C20.1153 79.3807 34.5978 82 51.5541 82C68.6024 82 82.9929 79.2905 82.9929 68.8132Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7514 25.3725C30.7514 36.6819 40.006 45.7451 51.5544 45.7451C63.0985 45.7451 72.3573 36.6819 72.3573 25.3725C72.3573 14.0631 63.0985 5 51.5544 5C40.006 5 30.7514 14.0631 30.7514 25.3725ZM82.9929 68.8132C82.9929 58.3441 68.5103 55.7248 51.5541 55.7248C34.5057 55.7248 20.1153 58.4343 20.1153 68.9116C20.1153 79.3807 34.5978 82 51.5541 82C68.6024 82 82.9929 79.2905 82.9929 68.8132Z",
    fill: "url(#paint1_linear_4139_1145)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5544 46.7451C39.4736 46.7451 29.7514 37.2538 29.7514 25.3725H31.7514C31.7514 36.1101 40.5385 44.7451 51.5544 44.7451V46.7451ZM73.3573 25.3725C73.3573 37.254 63.6309 46.7451 51.5544 46.7451V44.7451C62.5662 44.7451 71.3573 36.1099 71.3573 25.3725H73.3573ZM51.5544 4C63.6309 4 73.3573 13.4911 73.3573 25.3725H71.3573C71.3573 14.6351 62.5662 6 51.5544 6V4ZM29.7514 25.3725C29.7514 13.4912 39.4736 4 51.5544 4V6C40.5385 6 31.7514 14.635 31.7514 25.3725H29.7514ZM51.5541 54.7248C60.0541 54.7248 68.0519 55.3775 73.9557 57.3969C76.9134 58.4086 79.4183 59.7872 81.192 61.6648C82.9882 63.5663 83.9929 65.938 83.9929 68.8132H81.9929C81.9929 66.4539 81.1872 64.5722 79.7381 63.0382C78.2664 61.4803 76.0909 60.2411 73.3084 59.2893C67.7319 57.3818 60.0103 56.7248 51.5541 56.7248V54.7248ZM19.1153 68.9116C19.1153 66.0367 20.1124 63.6592 21.8998 61.748C23.6653 59.8602 26.1611 58.4686 29.1138 57.4444C35.0074 55.4002 43.0064 54.7248 51.5541 54.7248V56.7248C43.0534 56.7248 35.333 57.4042 29.7692 59.334C26.9933 60.2969 24.826 61.5471 23.3605 63.1141C21.9169 64.6577 21.1153 66.5479 21.1153 68.9116H19.1153ZM51.5541 83C43.054 83 35.0562 82.3474 29.1524 80.3279C26.1948 79.3162 23.6899 77.9377 21.9162 76.06C20.1199 74.1585 19.1153 71.7868 19.1153 68.9116H21.1153C21.1153 71.2709 21.9209 73.1526 23.37 74.6866C24.8417 76.2445 27.0172 77.4838 29.7997 78.4356C35.3763 80.3431 43.0978 81 51.5541 81V83ZM83.9929 68.8132C83.9929 71.6882 82.9957 74.0657 81.2083 75.9768C79.4428 77.8646 76.9471 79.2562 73.9943 80.2804C68.1007 82.3246 60.1017 83 51.5541 83V81C60.0548 81 67.7752 80.3207 73.3389 78.3908C76.1148 77.428 78.2821 76.1777 79.7476 74.6107C81.1912 73.0671 81.9929 71.1769 81.9929 68.8132H83.9929Z",
    fill: "url(#paint2_linear_4139_1145)",
    mask: "url(#path-4-outside-1_4139_1145)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4139_1145",
    x: 0.542419,
    y: 36.688,
    width: 65.2734,
    height: 49.306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "effect1_foregroundBlur_4139_1145"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4139_1145",
    x: 5.86484,
    y: 0.317993,
    width: 51.9673,
    height: 51.9673,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "effect1_foregroundBlur_4139_1145"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_4139_1145",
    x: -4.88474,
    y: -20,
    width: 112.878,
    height: 127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4139_1145"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4139_1145",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_4139_1145",
    x: -4.88474,
    y: -20,
    width: 112.878,
    height: 127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4139_1145"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4139_1145",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4139_1145",
    x1: 28.0097,
    y1: 10.7998,
    x2: 28.0097,
    y2: 70.1593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5DA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6DC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4139_1145",
    x1: 51.6026,
    y1: 4.88078,
    x2: 51.6026,
    y2: 82.7289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5DA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6DC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4139_1145",
    x1: 72.9838,
    y1: 13.9706,
    x2: 9.91328,
    y2: 64.2453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoingWell5);
export default __webpack_public_path__ + "static/media/doing-well5.4912c5485a9384d004d22e84b8bbb905.svg";
export { ForwardRef as ReactComponent };